import React from 'react'
import { SCHEDULE_TYPE } from '@trustero/trustero-api-web/lib/schedulemanager/schedulemanager_pb'
import { FilterName, FilterParam } from '../FilterBar.types'
import { FilterDropdown } from './FilterDropdown'

export const SCHEDULE_TYPE_OPTIONS = [
  {
    value: SCHEDULE_TYPE.EVIDENCE_COLLECTION.toString(),
    label: 'Evidence Collection',
  },
  {
    value: SCHEDULE_TYPE.EXAMINATION_AND_TEST.toString(),
    label: 'Examine and Test',
  },
]

export const ExecutionTypeFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => {
    return (
      <FilterDropdown
        filterParam={FilterParam.EXECUTION_TYPE}
        filterName={FilterName.EXECUTION_TYPE}
        filterValues={SCHEDULE_TYPE_OPTIONS}
        isNested={isNested}
      />
    )
  },
)
